import { getCourseId, getInstanceId } from "../../Utils/utils";
import { AdminCourseManagement } from "./AdminCourseManagement";

export function loadAdminCourseManagement(){
    const instanceId = getInstanceId();
    const courseId = getCourseId();

    new AdminCourseManagement(courseId, instanceId, '#admin-management-wrapper')
}